import { Component, OnInit, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange, MatRadioButton } from '@angular/material/radio';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { Service, QueueStatus, DateEvent, TimeSlot, QueueType, Consent } from '@app-models/site';
import { SiteService } from '@app-services/site.service';
import { ConfirmComponent } from '../../modals/confirm/confirm.component';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { errorMessages } from 'src/message/error';
import { LoadingScreenService } from '@app-services/loading-screen.service';
import { Moment } from 'moment';
import * as moment from 'moment';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { ThaiMomentDateAdapter } from '../../../thai-moment-date-adapter';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DateDialogComponent } from '../../core/date-dialog/date-dialog.component';
import { TimeslotDialogComponent } from '../../core/timeslot-dialog/timeslot-dialog.component';
import { QueuetypeComponent } from '../../modals/queuetype/queuetype.component';
import { ConsentDialogComponent } from '../../core/consent-dialog/consent-dialog.component';
import { InstructionComponent } from '../../modals/instruction/instruction.component';


@Component({
  selector: 'app-service-detail',
  templateUrl: './service-detail.component.html',
  styleUrls: ['./service-detail.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'th' },
    { provide: DateAdapter, useClass: ThaiMomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class ServiceDetailComponent implements OnInit, OnDestroy {

  latlongPattern = new RegExp(
    /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/);
  e = errorMessages.TH;
  confirmDialogRef: MatDialogRef<ConfirmComponent>;
  service: Service;
  eventSub: Subscription;
  numQueuesToNotify: number;
  @ViewChild('sixStatusRadio') sixStatusRadio: MatRadioButton;
  @ViewChild('sevenStatusRadio') sevenStatusRadio: MatRadioButton;
  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  fg: FormGroup;
  holidayGroups: DateEvent[][];
  holidayKeys: string[];
  sortedConsentKeys: string[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private ss: SiteService,
    public dialog: MatDialog,
    private ls: LoadingScreenService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    // this.service = this._ss.newService();
    this.numQueuesToNotify = 6;
    this.eventSub = this.route.params.subscribe(
      (params: Params) => {
        this.ss.getService(params.serviceId).then(
          async (service: Service) => {
            // MOCKUP DATA
            // service.maxReservedQueues = 5;
            // service.holidays = await this.getGoogleHolidays();
            // const [keys, groups] = this.ss.groupDateEventByMonthYear(
            //   service.holidays);
            // this.holidayGroups = groups;
            // this.holidayKeys = keys;
            // const slots = [];
            // for (const slot of this.ss.getAllTimeSlots()){
            //   if (Math.random() > 0.5) {
            //     slots.push(slot);
            //   }
            // }
            // service.openTimeSlots = slots;
            // service.timeslotSummary = this.ss.getTimeSlotSummary(service.openTimeSlots);
            // console.log(this.holidayGroups);
            // this.triggerResizeTextArea();
            // if (!service.queueTypes || service.queueTypes.length === 0) {
            //   service.queueTypes = [];
            //   service.queueTypes.push({
            //     name: 'Online queue',
            //     queueTypeId: 0,
            //     initialQueueNumber: 0,
            //     endQueueNumber: 0,
            //     isOnlineBookingAllowed: false,
            //     obMaxReservedQueues: 5,
            //     obTimeslotSummary: '',
            //     obOpenTimeSlots: []
            //   });
            // }

            // service.queueTypes.push({
            //   name: 'คิวสำหรับคนทำบัก',
            //   queueTypeId: 1,
            //   initialQueueNumber: 1000,
            //   endQueueNumber: 1999,
            //   isOnlineBookingAllowed: false
            // });
            // service.instructions = [];
            // end MOCKUP DATA
            if (service.consents) {
              this.sortedConsentKeys = Object.keys(service.consents).sort((a, b) => b.localeCompare(a));
            } else {
              this.sortedConsentKeys = [];
              service.consents = [];
            }
            if (this.sortedConsentKeys.length === 0 ||
                service.consents[this.sortedConsentKeys[0]].activeDatetime) {
              const newConsent: Consent = {
                id: moment().unix() + '',
                doc: null,
                activeDatetime: null,
                expiredDatetime: null,
              };
              service.consents[newConsent.id] = newConsent;
              this.sortedConsentKeys.unshift(newConsent.id);
            }

            if (!service.holidays) {
              service.holidays = [];
            }
            const [keys, groups] = this.ss.groupDateEventByMonthYear(
              service.holidays);
            this.holidayGroups = groups;
            this.holidayKeys = keys;
            this.initFormControls(service);
            this.service = service;
            // this.ss.getGoogleHolidays(2020, 2021);
          }
        );
      }
    );
  }

  ngOnDestroy() {
    this.eventSub.unsubscribe();
  }

  triggerResizeTextArea() {
    // Wait for changes to be applied, then trigger textarea resize.
    this.ngZone.onStable.pipe(take(1))
      .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  initFormControls(service: Service) {
    this.fg = this.fb.group({
      name: [service.name, Validators.required],
      displayId: [service.displayId, Validators.required],
      latlong: [
        service.latitude + ',' + service.longitude,
        [Validators.required, Validators.pattern(this.latlongPattern)]],
      radius: [service.checkInRadius, [
        Validators.required,
        Validators.pattern(/^[1-9]+(\.\d)?$/)]],
      numQueuesToNotify: [
        service.queueStatuses[0].numQueuesToNotify,
        [Validators.required, Validators.pattern(/^-?[0-9]+$/), Validators.min(1)]],
      // maxReservedQueues: [
      //   service.maxReservedQueues,
      //   [Validators.required, Validators.pattern(/^-?[0-9]+$/), Validators.min(1)]]
    });
  }

  async getGoogleHolidays() {
    const year = moment().year();
    return await this.ss.getGoogleHolidays(year, year + 1);
  }

  formatDate(date: Moment): string {
    return date.locale('th').format('D MMMM') + ' ' + (date.year() + 543);
  }

  confirmEnableChanged(event: MatSlideToggleChange) {
    // already changed
    // console.log(this.site.enabled);
    let actionMsg = 'ระงับ';
    if (this.service.isEnabled) {
      actionMsg = 'เปิด';
    }
    const header = actionMsg + 'การใช้งานจุดบริการ';
    const message = 'คุณกำลัง' + actionMsg + 'การใช้งานจุดบริการ คุณต้องการดำเนินงานต่อหรือไม่';
    this.confirmDialogRef = this.dialog.open(
      ConfirmComponent, {
      data: { header, message }
    }
    );
    this.confirmDialogRef.afterClosed().subscribe(
      (confirm: any) => {
        if (confirm) {
          this.updateService(this.service, { isEnabled: this.service.isEnabled });
        } else {
          this.service.isEnabled = !this.service.isEnabled;
        }
      }
    );
  }

  confirmEnableChangedShowInApp(event: MatSlideToggleChange) {
    // already changed
    // console.log(this.site.enabled);
    let actionMsg = 'ระงับ';
    if (this.service.isShown) {
      actionMsg = 'เปิด';
    }
    const header = actionMsg + 'การใช้งานจุดบริการ';
    const message = 'คุณกำลัง' + actionMsg + 'การแสดงผลจุดบริการ คุณต้องการดำเนินงานต่อหรือไม่';
    this.confirmDialogRef = this.dialog.open(
      ConfirmComponent, {
      data: { header, message }
    }
    );
    this.confirmDialogRef.afterClosed().subscribe(
      (confirm: any) => {
        if (confirm) {
          this.updateService(this.service, { isShown: this.service.isShown });
        } else {
          this.service.isShown = !this.service.isShown;
        }
      }
    );
  }

  numStatusesChanged(change: MatRadioChange) {
    // const statusList = 'Queue_Receive'
    const header = 'เปลียนจำนวนสถานะ';
    const message = [
      'คุณกำลังเปลี่ยนจาก ',
      this.service.queueStatuses.length,
      ' สถานะเป็น ',
      change.value,
      ' สถานะ สถานะที่จะมีคือ ',
      this.ss.getAllStatusString(this.service.queueStatuses.length === 7)
    ].join('');
    if (change.value !== this.service.queueStatuses.length) {
      this.confirmDialogRef = this.dialog.open(
        ConfirmComponent, {
        data: { header, message }
      }
      );
      this.confirmDialogRef.afterClosed().subscribe(
        (confirm: any) => {
          if (confirm) {
            if (change.value === 7) {
              this.service.queueStatuses.splice(
                2, 0, this.ss.getDefaultQueueScanStatus());
            } else if (change.value === 6) {
              this.service.queueStatuses.splice(2, 1);
            }
            this.updateService(this.service, { queueStatuses: this.service.queueStatuses });
          } else {
            if (change.source.radioGroup.selected !== this.sixStatusRadio) {
              change.source.radioGroup.selected = this.sixStatusRadio;
            } else {
              change.source.radioGroup.selected = this.sevenStatusRadio;
            }
          }
        }
      );
    }
  }

  editFormGroup(update: boolean) {
    if (update) {
      this.service.name = this.fg.get('name').value;
      this.service.displayId = this.fg.get('displayId').value;
      const numQ = this.fg.get('numQueuesToNotify').value;
      for (const status of this.service.queueStatuses) {
        status.numQueuesToNotify = numQ;
      }
      // this.service.maxReservedQueues = this.fg.get('maxReservedQueues').value;
      const latlong = this.fg.get('latlong').value.split(',');
      this.service.latitude = latlong[0];
      this.service.longitude = latlong[1];
      this.service.checkInRadius = this.fg.get('radius').value;
      // console.log(latlong);
      const changes = Object.assign({}, this.service);
      // console.log(changes);
      delete changes.holidays;
      // delete changes.openTimeSlots;
      // delete changes.timeslotSummary;
      delete changes.consents;
      delete changes.isEnabled;
      this.updateService(this.service, changes);
    } else {
      this.fg.get('name').setValue(this.service.name);
      this.fg.get('displayId').setValue(this.service.displayId);
      this.fg.get('numQueuesToNotify').setValue(this.service.queueStatuses[0].numQueuesToNotify);
      this.fg.get('latlong').setValue(this.service.latitude + ',' + this.service.longitude);
      this.fg.get('radius').setValue(this.service.checkInRadius);
      // this.fg.get('maxReservedQueues').setValue(this.service.maxReservedQueues);
    }
  }

  confirmNotifyChanged(event: MatSlideToggleChange, i: number) {
    // already changed
    // console.log(this.site.enabled);
    const status: QueueStatus = this.service.queueStatuses[i];
    let actionMsg = 'ปิด';
    if (status.shouldNotify) {
      actionMsg = 'เปิด';
    }
    const header = actionMsg + 'การแจ้งเตือน';
    const message = 'คุณกำลัง' + actionMsg + 'การแจ้งเตือนของสถานะ ' + status.name + ' คุณต้องการดำเนินงานต่อหรือไม่';
    this.confirmDialogRef = this.dialog.open(
      ConfirmComponent, {
      data: { header, message }
    }
    );
    this.confirmDialogRef.afterClosed().subscribe(
      (confirm: any) => {
        if (confirm) {
          this.updateService(this.service, { queueStatuses: this.service.queueStatuses });
        } else {
          status.shouldNotify = !status.shouldNotify;
        }
      }
    );
  }

  updateService(service: Service, changes: any) {
    this.ls.startLoading();
    // console.log(changes);
    this.ss.updateService(service, changes)
      .then(() => { })
      .finally(() => { this.ls.stopLoading(); });
  }

  confirmDeleteDialog() {
    const header = null;
    const message = null;
    this.confirmDialogRef = this.dialog.open(
      ConfirmComponent, {
      data: { header, message, warn: true }
    }
    );
    this.confirmDialogRef.afterClosed().subscribe(
      (confirm: any) => {
        if (confirm) {
          this.ls.startLoading();
          // console.log(this.service);
          this.ss.deleteService(this.service.id)
            .then(() => {
              this.ss.deleteServiceLocal(this.service);
              this.router.navigate(['../../'], { relativeTo: this.route });
            }).finally(() => { this.ls.stopLoading(); });
        }
      }
    );
  }

  openDateDialog() {
    const dialogRef = this.dialog.open(DateDialogComponent, {
      data: {holidays: this.service.holidays, openOnWeekends: this.service.openOnWeekends}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.openOnWeekends = result.openOnWeekends;
        this.service.holidays = result.holidays;
        const changes = [];
        for (const h of this.service.holidays) {
          changes.push({ date: h.date.locale('th').format(), name: h.name });
        }
        this.updateService(this.service, { holidays: changes,  openOnWeekends: this.service.openOnWeekends});
        const [keys, groups] = this.ss.groupDateEventByMonthYear(
          this.service.holidays);
        this.holidayGroups = groups;
        this.holidayKeys = keys;
      }
    });
  }

  openInstructionDialog() {
    const dialogRef = this.dialog.open(InstructionComponent, {
      data: this.service.instructions,
      minWidth: 400
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.instructions = result;
        this.updateService(this.service, { instructions: this.service.instructions });
      }
    });
  }

  // openTimeslotDialog() {
  //   const dialogRef = this.dialog.open(TimeslotDialogComponent, {
  //     data: this.service.openTimeSlots,
  //     minWidth: 300
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       result = result.sort(this.ss.compareTimeSlot);
  //       this.service.openTimeSlots = result;
  //       this.service.timeslotSummary = this.ss.getTimeSlotSummary(result);
  //       this.triggerResizeTextArea();
  //       this.updateService(this.service, {
  //         openTimeSlots: this.service.openTimeSlots,
  //         timeslotSummary: this.service.timeslotSummary
  //       });
  //     }
  //   });
  // }

  openQueueTypeDialog(qtype: QueueType, index: number) {
    const dialogRef = this.dialog.open(QueuetypeComponent, {
      data: {
        selectedQueueType: qtype,
        selectedIndex: index,
        allQueueTypes: this.service.queueTypes,
        activeConsentId: this.service.activeConsentId,
        openOnWeekends: this.service.openOnWeekends
      },
      minWidth: 500,
      minHeight: 611
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (!this.service.queueTypes) {
          this.service.queueTypes = [];
        }
        if (result === 'deleted') {

          this.confirmDialogRef = this.dialog.open(
            ConfirmComponent, {
            data: {
              header: 'ยืนยันการลบประเภทคิว',
              message: 'คุณต้องการลบประเภทคิวนี้ออกจากระบบใช่หรือไม่',
              warn: true }
          }
          );
          this.confirmDialogRef.afterClosed().subscribe(
            (confirm: any) => {
              if (confirm) {
                this.service.queueTypes.splice(index, 1);
                this.updateService(this.service, {queueTypes: this.service.queueTypes});
              }
            }
          );
        } else {
          if (index === -1) {
            this.service.queueTypes.push(result);
          } else {
            Object.assign(qtype, result);
          }
          // console.log(qtype);
          this.updateService(this.service, {queueTypes: this.service.queueTypes});
        }
        // result = result.sort(this.ss.compareTimeSlot);
        // this.service.openTimeSlots = result;
        // this.service.timeslotSummary = this.ss.getTimeSlotSummary(result);
        // this.triggerResizeTextArea();
        // this.updateService(this.service, {
        //   openTimeSlots: this.service.openTimeSlots,
        //   timeslotSummary: this.service.timeslotSummary
        // });
      }
    });
  }

  formatDateDefault(date: moment.Moment, defaultVal: string): string {
    if (date) {
      return date.locale('th').format('D MMMM') + ' ' + (date.year() + 543);
    } else {
      return defaultVal;
    }
  }

  formatConsent(consent: Consent): string {
    if (!consent.activeDatetime && !consent.expiredDatetime) {
      if (consent.doc) {
        return 'เอกสารร่าง';
      } else {
        return 'เอกสารใหม่';
      }
    } else if (!consent.expiredDatetime) {
      return 'เอกสารปัจจุบัน (' + this.formatDateDefault(consent.activeDatetime, '') + ')';
    } else {
      return 'เอกสารเก่า (' +
        this.formatDateDefault(consent.activeDatetime, '') +
        ' ถึง ' +
        this.formatDateDefault(consent.expiredDatetime, '') +
        ')';
    }
  }

  openConsentDialog(consent: Consent) {
    if (consent.doc && !consent.docData) {
      this.ss.getConsentContent(consent.doc).then((content) => {
        consent.docData = content;
        this._openConsentDialog(consent);
      });
    } else {
      this._openConsentDialog(consent);
    }
  }

  private _openConsentDialog(consent: Consent) {
    const dialogRef = this.dialog.open(
      ConsentDialogComponent, {
      data: consent,
      minWidth: 800
    });
    dialogRef.afterClosed().subscribe(
      async (newConsent: Consent) => {
        if (newConsent) {
          // console.log(newConsent);
          this.ls.startLoading();
          const site = await this.ss.getCurrentSite();
          this.ss.uploadConsentFile(site.id, this.service.id, newConsent).then((url) => {
            newConsent.doc = url;
            Object.assign(consent, newConsent);
            if (consent.activeDatetime) {
              for (const cid in this.service.consents) {
                if (Object.prototype.hasOwnProperty.call(this.service.consents, cid)) {
                  const c = this.service.consents[cid];
                  if (!c.expiredDatetime && c !== consent) {
                    c.expiredDatetime = consent.activeDatetime;
                  }
                }
              }
              this.service.activeConsentId = consent.id;
              this.updateService(this.service, { activeConsentId: consent.id });
              const tempConsent: Consent = {
                id: moment().unix() + '',
                doc: null,
                activeDatetime: null,
                expiredDatetime: null,
              };
              this.service.consents[tempConsent.id] = tempConsent;
              this.sortedConsentKeys.unshift(tempConsent.id);
            }
            this.ss.updateServiceConsent(site.id, this.service, consent)
              .then(() => {
                // this.cdkRef.detectChanges();
                // this.ss.updateLocalSiteList(this.site)
                //   .then(() => {
                //     this.cdkRef.detectChanges();
                //   }
                //   );
              }
              ).finally(() => { this.ls.stopLoading(); });
          });
        }
      }
    );
  }

}
